import React from 'react';
import { motion } from 'framer-motion';

export default function SectionLabel({ children, className = '' }) {
  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className={`flex items-center gap-4 ${className}`}
    >
      <span className="text-xs tracking-[0.3em] uppercase text-cyan-400 font-rajdhani">
        {children}
      </span>
      <span className="h-px flex-1 max-w-[100px] bg-gradient-to-r from-cyan-500/50 to-transparent" />
    </motion.div>
  );
}
